import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setCommissionMode } from 'bundles/apex/deals/form/store/deal/actions';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { commissionUnitOptions } from 'components/lease_structure/form/helpers/select_options';

export function DealCommissionModeInput({ deal, required, setCommissionMode }) {
  return (
    <ManagedFormGroup
      label="Commission Units"
      required={required}
      type="select"
      value={deal.commissionMode}
      onValueChange={setCommissionMode}
    >
      {commissionUnitOptions({ spaceSizeUnits: deal.spaceSizeUnits }).map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </ManagedFormGroup>
  );
}

DealCommissionModeInput.propTypes = {
  deal: PropTypes.shape({
    commissionMode: PropTypes.string,
  }).isRequired,
  required: PropTypes.bool,
  setCommissionMode: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

const mapDispatchToProps = {
  setCommissionMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealCommissionModeInput);
